// @ts-nocheck
import React from 'react';
import { sx } from '../sx';

const inputStyle = sx(
  `width:100%;height:40px;padding:0 13px;border:1px solid #C8D4EA;border-radius:8px;background:#fff;font-family:inherit;font-size:13px;color:var(--ink);outline:none;box-sizing:border-box`
);

const overwriteInputStyle = sx(
  `width:100%;height:38px;margin-top:8px;padding:0 13px;border:1px solid rgba(229,72,77,.55);border-radius:8px;background:#fff;font-family:inherit;font-size:13px;letter-spacing:0.06em;color:var(--ink);outline:none;box-sizing:border-box`
);

export default function PublishModal({ vm }: { vm: any }) {
  if (!vm.publishOpen) return null;

  return (
    <div
      style={sx(
        `position:fixed;inset:0;z-index:60;background:rgba(8,35,76,0.45);display:flex;align-items:center;justify-content:center;padding:24px`
      )}
    >
      <div
        style={sx(
          `width:100%;max-width:380px;max-height:calc(100vh - 48px);overflow:auto;border-radius:24px;box-shadow:0 30px 60px -25px rgba(8,35,76,0.5)`
        )}
      >
        <div
          style={sx(
            `width:100%;background:var(--navy);border-radius:24px;padding:22px;color:rgba(255,255,255,.78);position:relative;overflow:hidden`
          )}
        >
          <div
            style={sx(
              `position:absolute;inset:0;background:radial-gradient(600px 320px at 12% 14%, rgba(0,179,255,0.18), transparent 60%),radial-gradient(460px 260px at 88% 86%, rgba(176,203,31,0.10), transparent 60%);pointer-events:none`
            )}
          />
          <div style={sx(`position:relative`)}>
            <div style={sx(`display:flex;align-items:center;gap:10px`)}>
              <div
                style={sx(
                  `flex:1;min-width:0;font-size:11px;font-weight:500;letter-spacing:0.14em;text-transform:uppercase;color:rgba(255,255,255,.40)`
                )}
              >
                Publish
              </div>
              <button
                className="gmHover"
                onClick={vm.closePublish}
                style={sx(
                  `flex:none;width:26px;height:26px;display:flex;align-items:center;justify-content:center;border:1px solid rgba(255,255,255,.24);border-radius:999px;background:transparent;color:#fff;font-family:inherit;font-size:13px;line-height:1;cursor:pointer`
                )}
                data-hover="background:rgba(255,255,255,0.10)"
              >
                ×
              </button>
            </div>
            <div
              style={sx(
                `font-size:20px;font-weight:600;color:#fff;letter-spacing:-0.03em;margin:6px 0 18px`
              )}
            >
              {vm.publishVersionLabel}
            </div>
            {vm.publishFlags && vm.publishFlags.length ? (
              <div data-testid="publish-flags" style={sx(`margin-top:14px;padding:11px 13px;border-radius:12px;background:rgba(229,72,77,0.16)`)}>
                <div style={sx(`font-size:11.5px;color:#ffd9da;line-height:1.5;margin-bottom:6px`)}>
                  {vm.publishFlagsNote}
                </div>
                <div style={sx(`max-height:180px;overflow:auto`)}>
                  {vm.publishFlags.map((f, fIdx) => (
                    <div key={fIdx} style={sx(`display:flex;justify-content:space-between;align-items:center;gap:12px;padding:3px 0;font-size:12px`)}>
                      <span style={sx(`flex:1;min-width:0;color:rgba(255,255,255,.72)`)}>{f.label}</span>
                      <span style={sx(`flex:none;color:#fff;font-variant-numeric:tabular-nums`)}>{f.value}</span>
                      {f.onGo ? (
                        <button type="button" onClick={f.onGo} style={sx(`flex:none;padding:0;border:none;background:none;font-family:inherit;font-size:12px;color:#9cc3ff;cursor:pointer;text-decoration:underline;text-underline-offset:2px`)}>
                          Go to
                        </button>
                      ) : null}
                    </div>
                  ))}
                </div>
              </div>
            ) : null}
            {vm.publishGuardNotes && vm.publishGuardNotes.length ? (
              <div data-testid="publish-guard-notes" style={sx(`margin-top:14px;padding:11px 13px;border-radius:12px;background:rgba(255,237,0,0.12)`)}>
                <div style={sx(`font-size:11.5px;color:#fff6b3;line-height:1.5;margin-bottom:6px`)}>
                  These settings have no value yet, so their rules are skipped in this version. You can still publish.
                </div>
                {vm.publishGuardNotes.map((t, tIdx) => (
                  <div key={tIdx} style={sx(`padding:3px 0;font-size:12px;color:rgba(255,255,255,.72)`)}>{t}</div>
                ))}
              </div>
            ) : null}
            <div style={sx(`margin-top:18px`)}>
              <span
                style={sx(
                  `display:block;font-size:11px;font-weight:500;letter-spacing:0.08em;text-transform:uppercase;color:rgba(255,255,255,.40);margin-bottom:7px`
                )}
              >
                Forecast version name
              </span>
              <input
                className="gmFocus"
                autoFocus
                value={vm.pubName}
                onChange={vm.publishing ? undefined : vm.onPubName}
                onClick={vm.stopClose}
                disabled={!!vm.publishing}
                placeholder="Forecast_2026_June_v1"
                style={inputStyle}
              />
            </div>
            <div
              style={sx(
                `display:flex;align-items:flex-start;gap:9px;margin-top:10px;padding:11px 13px;border-radius:12px;background:${vm.pubMsgBg}`
              )}
            >
              <span
                style={sx(
                  `flex:none;width:6px;height:6px;margin-top:5px;border-radius:999px;background:${vm.pubMsgDot}`
                )}
              />
              <div
                style={sx(
                  `flex:1;min-width:0;font-size:11.5px;color:${vm.pubMsgFg};line-height:1.5`
                )}
              >
                {vm.pubMsg}
              </div>
              {vm.pubNeedsUnlock ? (
                <button
                  onClick={vm.unlockTarget}
                  style={sx(
                    `flex:none;height:26px;padding:0 11px;border:1px solid rgba(255,255,255,.28);border-radius:999px;background:transparent;color:#fff;font-family:inherit;font-size:11.5px;cursor:pointer`
                  )}
                >
                  Unlock
                </button>
              ) : null}
            </div>
            {vm.pubNeedsOverwrite ? (
              <input
                className="gmFocus"
                value={vm.pubConfirm}
                onChange={vm.onPubConfirm}
                onClick={vm.stopClose}
                placeholder="Type OVERWRITE"
                style={overwriteInputStyle}
              />
            ) : null}
            <button
              onClick={vm.publishing ? undefined : vm.doPublish}
              disabled={!!vm.publishing}
              style={sx(
                `width:100%;height:42px;margin-top:12px;border:none;border-radius:999px;font-family:inherit;font-size:13px;font-weight:500;cursor:${vm.publishCursor};background:${vm.publishBg};color:${vm.publishFg};opacity:${vm.publishing ? "0.9" : "1"}`
              )}
            >
              {vm.publishLabel}
            </button>
            {vm.hasBlockers ? (
              <button
                className="gmHover"
                onClick={vm.goGovernance}
                style={sx(
                  `width:100%;height:36px;margin-top:8px;border:1px solid rgba(255,255,255,.24);border-radius:999px;background:transparent;color:#fff;font-family:inherit;font-size:12.5px;cursor:pointer`
                )}
                data-hover="background:rgba(255,255,255,0.10)"
              >
                {vm.openReviewLabel}
              </button>
            ) : null}
            <p
              style={sx(
                `font-size:11.5px;color:rgba(255,255,255,.40);margin:12px 0 0;line-height:1.5`
              )}
            >
              {vm.publishNote}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
